import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { HeaderService } from '../../../../services/header/header.service';
import { ExportService } from '../../shared/export.service';
import { ToastrService } from 'ngx-toastr';
import {DataService} from '../../../../services/commande-client/data.service';
import {SmsModalComponent} from './sms-modal/sms-modal.component';

@Component({
    selector: 'app-commande-client',
    templateUrl: './commande-client.component.html',
    styleUrls: ['./commande-client.component.scss']
})
export class CommandeClientComponent implements OnInit {
    currentStatus: string = 'tous';
    statuses: string[] = ['tous', 'brouillon', 'valide', 'cree', 'annule'];
    currentUser: any = null;
    userId: number | null = null;
    stationId: number | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService,
        private headerService: HeaderService,
        private exportService: ExportService,
        private toastr: ToastrService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.userId = this.currentUser?.id || null;
        this.stationId = this.currentUser?.stations?.[0]?.id || null;
    }

    ngOnInit(): void {
        console.log('CommandeClientComponent initialized');
        this.headerService.setConfig({
            title: 'Commande Client',
            buttons: [
                {
                    label: 'Exporter',
                    type: 'dropdown',
                    dropdownItems: [
                        {
                            label: 'PDF',
                            action: () => this.exportService.triggerPDF(),
                            icon: '../../../assets/images/logo/pdf_logo.png'
                        },
                        {
                            label: 'CSV',
                            action: () => this.exportToCSV(),
                            icon: '../../../assets/images/logo/csv_logo.png'
                        }
                    ]
                }
            ]
        });
        // Mettre à jour currentStatus à partir de l'URL
        this.route.firstChild?.url.subscribe(segments => {
            const path = segments.length > 0 ? segments[0].path : 'tous';
            this.currentStatus = path.toLowerCase();
            console.log('Current status set to:', this.currentStatus); // Debug
        });
    }


    filterByStatus(status: string) {
        this.currentStatus = status.toLowerCase();
        const mappedStatus = this.mapPathToStatus(status);

        this.dataService.loadByTypeAndStatus('commande-client', mappedStatus);

        this.router.navigate([`/vente/commande-client/${status.toLowerCase()}`]);
    }

    private mapPathToStatus(path: string): string {
        const statusMap: { [key: string]: string } = {
            tous: 'Tous',
            brouillon: 'Brouillon',
            cree: 'Crée',
            annule: 'Annulé',
            valide: 'Valide'
        };
        return statusMap[path.toLowerCase()] || 'Tous';
    }

    getStatusCount(status: string): number {
        return this.dataService.getOrderStatusCount(status);
    }

    private exportToCSV(): void {
        const data = this.dataService.getOrderTableData();
        const headers = ['Référence', 'Client', 'Date', 'Revenu', 'Matricule', 'Statut'];
        const rows = data.map(item => [
            `"${(item.reference || '').replace(/"/g, '""')}"`,
            `"${(item.clientName || '').replace(/"/g, '""')}"`,
            `"${(item.date || '').replace(/"/g, '""')}"`,
            `"${(item.revenue || '').replace(/"/g, '""')}"`,
            `"${(item.matricule || '').replace(/"/g, '""')}"`,
            `"${(item.status || '').replace(/"/g, '""')}"`
        ]);
        const csvContent = headers.join(',') + '\n' + rows.map(row => row.join(',')).join('\n');
        this.exportService.downloadCSV(csvContent, 'commande-client.csv');
    }
}
